import type { CSSProperties } from "react";
import { agendaStatusLabelPt, isClassFullStatus } from "@/lib/agenda-status";

type Tone = "ok" | "err" | "warn" | "pending" | "lime" | "muted";

const TONE: Record<Tone, CSSProperties> = {
  ok: { color: "var(--cb-success)", background: "var(--cb-success-dim)", borderColor: "rgba(0,232,122,.28)" },
  err: { color: "var(--cb-error)", background: "var(--cb-error-dim)", borderColor: "rgba(255,68,55,.28)" },
  warn: { color: "var(--cb-warning)", background: "var(--cb-warning-dim)", borderColor: "rgba(255,182,46,.28)" },
  pending: { color: "var(--cb-pending)", background: "var(--cb-pending-dim)", borderColor: "rgba(139,149,246,.28)" },
  lime: { color: "var(--cb-accent)", background: "var(--cb-accent-dim)", borderColor: "var(--cb-accent-border)" },
  muted: { color: "var(--cb-muted)", background: "transparent", borderColor: "var(--cb-border2)" },
};

function Pill({ tone, label }: { tone: Tone; label: string }) {
  return (
    <span className="cb-pill" style={TONE[tone]}>
      {label}
    </span>
  );
}

const ATTEMPT_TONES: Record<string, Tone> = {
  success: "ok",
  failed: "err",
  full: "warn",
  given_up: "err",
  pending: "pending",
};

const ATTEMPT_LABELS: Record<string, string> = {
  success: "check-in ok",
  failed: "falhou",
  full: "turma cheia",
  given_up: "desistiu",
  pending: "em curso",
};

export function AttemptPill({ status }: { status: string }) {
  return <Pill tone={ATTEMPT_TONES[status] ?? "muted"} label={ATTEMPT_LABELS[status] ?? status} />;
}

/** Agenda item status, treating a full class (by status or occupancy) as full. */
export function AgendaPill({
  status,
  ocupacao,
  capacidade,
}: {
  status: number;
  ocupacao: number;
  capacidade: number;
}) {
  if (status === 5) return <Pill tone="ok" label="inscrito" />;
  if (isClassFullStatus(status) || (capacidade > 0 && ocupacao >= capacidade)) {
    return <Pill tone="warn" label="lotada" />;
  }
  if (status === 1) return <Pill tone="lime" label="disponível" />;
  if (status === 9) return <Pill tone="muted" label="abre em breve" />;
  return <Pill tone="muted" label={agendaStatusLabelPt(status)} />;
}
